module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n\t <my-factura-consultar></my-factura-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/factura/factura.component.html
// module id = ./src/app/factura/factura.component.html
// module chunks = main